import styled from 'styled-components';

const InfoDetailStyled = styled.div`
  .first_section {
    border-radius: 12px;
    padding: 20px 32px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      .title {
        font-size: 18px;
        font-weight: 600;
        color: #212121;
        line-height: 25px;
      }
      .time {
        font-size: 16px;
        font-weight: 400;
        color: #212121;
        line-height: 22px;
        margin-top: 8px;
      }
    }
    .replayIcon {
      transform: rotateY(180deg) rotate(320deg);
    }
  }
  .second_section {
    margin-top: 4px;
    border-radius: 12px;
    background-color: #fff;
    padding: 24px 0 24px 0;
    display: flex;
    gap: 1px;
    > div {
      width: 50%;
      padding-left: 32px;
      &:first-child {
        border-right: 1px solid #e5e5e5;
      }
    }
    .title {
      display: flex;
      align-items: center;
      .icon {
        width: 25px;
        height: 25px;
      }
      font-size: 18px;
      font-weight: 600;
      color: #111111;
      line-height: 25px;
      .title_text {
        margin-left: 2px;
      }
    }
    .data_content {
      height: 132px;
      display: flex;
      gap: 1px;
      > div {
        width: 238px;
        display: flex;
        flex-direction: column;
        padding-right: 36px;
        align-items: flex-end;
        .item_title {
          margin-left: auto;
          font-size: 14px;
          font-weight: 400;
          color: #212121;
          line-height: 20px;
          display: flex;
          align-items: center;
          span {
            margin-left: 4px;
          }
        }
        .item_num {
          font-size: 32px;
          font-weight: bold;
          color: #1565c0;
          height: 38px;
          line-height: 39px;
          display: flex;
          justify-content: center;
        }
        .wrapper {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }
        .hitRate {
          position: relative;
          display: flex;
          justify-content: space-between;
          min-width: 108px;
          gap: 24px;
          .text {
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
          }
          .percent {
            flex: 1;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            line-height: 19px;
            text-align: right;
          }
          .floatText {
            position: absolute;
            right: -14px;
            top: 0;
            font-size: 10px;
            font-weight: 400;
            color: #999999;
            line-height: 20px;
            /* transform:scale(); */
          }
        }
        .item_describe {
          width: 108px;
          .icon {
            width: 108px;
            height: 22px;
          }
          /* padding: 8px 6px 8px 2px; */
        }
      }
    }
  }
`;
export default InfoDetailStyled;
